const Colors = {
    "RED": { "strongColor": "#E6BCAD", "name": "RED", "color": "#f8ece8", "displayName": "Röd" },
    "BLUE": { "strongColor": "#add8e6", "name": "BLUE", "color": "#e8f4f8", "displayName": "Blå" },
    "YELLOW": { "strongColor": "#fafa87", "name": "YELLOW", "color": "#fdfdd0", "displayName": "Reservdrag" }
};


export default Colors;